<template>
    <ies-form-field :field="field">
        <div class="d-flex flex-column">
            <input type="hidden" :name="field.fieldName" :value="field.value">

            <v-radio-group
                v-model="depositRequired"
                row
                autocomplete>
                <v-radio label="Yes"		:value="1"></v-radio>
                <v-radio label="No"			:value="0"></v-radio>
                <v-radio label="Sometimes"	:value="2"></v-radio>
            </v-radio-group>
        </div>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-input-deposit-required',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
			depositRequired: parseInt(this.field.value),
        }
    },
	created: function() {
	
	},
	watch: {
		depositRequired: function (newValue) {
			this.field.value = newValue;
		}
	}	
}
</script>

